import { getTextWidth } from '@/utils/util'
import VideoEnPlayer from '../Player'
import VideoEvents from '../event'

export default class VideoDragFixInt {
  player: VideoEnPlayer;
  event: VideoEvents;
  target: HTMLElement;
  dataState: {
    dragIng: boolean;
    position: { x: number; y: number };
    pressedDelta: any;
  }

  constructor(player: VideoEnPlayer, event: VideoEvents) {
    this.player = player
    this.event = event

    this.target = this.player.container


    this.dataState = {
      dragIng: false,
      position: { x: 0, y: 0 },
      pressedDelta: {},
    }

    this.start = this.start.bind(this)
    this.move = this.move.bind(this)
    this.end = this.end.bind(this)
  }

  start(e) {
    const event = e.touches[0] || e.changedTouches[0];
    this.dataState.dragIng = true
    const rect = this.target.getBoundingClientRect()
    const pos = {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top
    }
    this.dataState.pressedDelta = pos
  }

  move(e) {
    e.preventDefault();
    const event = e.touches[0] || e.changedTouches[0];
    if (!this.dataState.pressedDelta)
      return
    this.dataState.position = {
      x: event.clientX - this.dataState.pressedDelta.x,
      y: event.clientY - this.dataState.pressedDelta.y
    }

    const headerHeight = document.querySelector('#header').getBoundingClientRect().height

    let top = getTextWidth('', {
      width: `${0.2 / 37.5}rem`,
      display:'block'
    })

    top = -top

    const maxX = window.innerWidth - this.target.getBoundingClientRect().width
    const maxY = window.innerHeight - this.target.getBoundingClientRect().height

    if (this.dataState.position.y < (headerHeight + top)) this.dataState.position.y = headerHeight + top
    if (this.dataState.position.y > maxY) this.dataState.position.y = maxY
    if (this.dataState.position.x < 0) this.dataState.position.x = 0
    if (this.dataState.position.x > maxX) this.dataState.position.x = maxX

    this.target.style.left = `${this.dataState.position.x}px`
    this.target.style.top = `${this.dataState.position.y}px`
  }

  end() {
    if (!this.dataState.pressedDelta)
      return
    this.dataState.pressedDelta = undefined
    this.dataState.dragIng = false
  }

  handleDrag() {
    if (!this.target) return
    this.target.addEventListener('touchstart', this.start)
    this.target.addEventListener('touchmove', this.move)
    this.target.addEventListener('touchend', this.end)
  }

  removeDrag() {
    if (!this.target || !this.target) return
    this.target.removeEventListener('touchstart', this.start)
    this.target.removeEventListener('touchmove', this.move)
    this.target.removeEventListener('touchend', this.end)
  }
}
